import { useCallback, useEffect, PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { Badge } from 'antd'

import { notificationManager } from '../Stores/NotificationManager'
import { NotificationDrawer } from '../Components/NotificationDrawer'
import { LoadUnreadCountTask } from '../Tasks/LoadUnreadCountTask'

import styles from './useNotificationDrawer.module.css'

export const useNotificationDrawer = () => {
    useEffect(() => {
        LoadUnreadCountTask()
    }, [])

    const openNotificationDrawer = useCallback(() => {
        // Global entry point (header bell) — always unscoped (all notifications).
        notificationManager.setEntityFilter(null)
        notificationManager.setIsDrawerOpen(true)
    }, [])

    const NotificationBadge = observer(({ children }: PropsWithChildren) => {
        return (
            <Badge
                count={notificationManager.unreadCount}
                overflowCount={99}
                size="small"
                classNames={{ indicator: styles['indicator'] as string }}
            >
                {children}
            </Badge>
        )
    })

    return {
        openNotificationDrawer,
        NotificationBadge,
        NotificationDrawer,
    }
}
